'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _contactAddAccountModal = require('./contactAddAccountModal.html');

var _contactAddAccountModal2 = _interopRequireDefault(_contactAddAccountModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactAddController = function () {
    function ContactAddController($scope, $state, $stateParams, $ionicPopup, $ionicLoading, ApiContacts, ApiInvestors, ApiCampaigns, ApiTeam, ApiPicklist, DATE_FORMAT, MessageBox, $rootScope, $ionicModal) {
        _classCallCheck(this, ContactAddController);

        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.ApiContacts = ApiContacts;
        this.ApiInvestors = ApiInvestors;
        this.ApiPicklist = ApiPicklist;
        this.ApiTeam = ApiTeam;
        this.MessageBox = MessageBox;
        this.$rootScope = $rootScope;

        this.investors = [];
        this.contactInfo = {};
        this.contactInfo.contact = {};
        this.loading = [];
        this.filter = {};
        this.DATE_FORMAT = DATE_FORMAT;
        this.contactId = $stateParams.contactId;
        this.isCustomerContact = false;
        this.editMode = false; // flag true if new entry
        this.createInvestor = false;
        this.investorRedirect = false; // flag true if redirected from investor detail page
        this.translationVisible = false;
        this.contactInfo.contact.businessCardInformationReceivedDate = this.DATE_FORMAT;
        this.contactInfo.contact.businessCardInformationLastUpdatedDate = this.DATE_FORMAT;

        this.addAccountModal = $ionicModal.fromTemplate(_contactAddAccountModal2.default, { scope: $scope });
        this.accountTypes = [{ id: 'PACKAGE', value: 'advinda accounts', selected: true }, { id: 'TEAM', value: 'custom accounts', selected: false }];
        this.customCount = this.$stateParams.customCount;
        this.advindaCount = this.$stateParams.advindaCount;

        var self = this;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParam) {
            if (self.cancelModal() != null) self.cancelModal();
        });

        this.cleaveNumeral = {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand'
        };
    }

    _createClass(ContactAddController, [{
        key: 'init',
        value: function init() {

            if (this.editMode) {
                this.$rootScope.pageTitle = 'EDIT_CONTACT';
            } else {
                this.$rootScope.pageTitle = 'CREATE_CONTACT';
            }
            this.getInvestorTypes();
            this.getInvestorSubtypes();

            this.getCountries();
            this.getTeams();
            if (this.isEdit()) this.getContact(this.contactId);
            if (this.isRedirectedFromInvestorsPage()) {

                this.contactInfo.investor = this.$stateParams.investor;

                this.copyInvestorToContact();
            }
        }
    }, {
        key: 'showLoading',
        value: function showLoading() {
            this.loading.push(1);
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
        }
    }, {
        key: 'hideLoading',
        value: function hideLoading() {
            this.loading.pop();
            if (this.loading.length === 0) this.$ionicLoading.hide();
        }
    }, {
        key: 'isEdit',
        value: function isEdit() {
            this.editMode = !!this.$stateParams.contactId;
            return this.editMode;
        }
    }, {
        key: 'isRedirectedFromInvestorsPage',
        value: function isRedirectedFromInvestorsPage() {
            this.investorRedirect = !!this.$stateParams.investor;
            return this.investorRedirect;
        }
    }, {
        key: 'getContact',
        value: function getContact(contactId) {
            var _this = this;

            this.showLoading();
            this.ApiContacts.getContact(contactId, { 'isCustomerContact': true }).then(function (contact) {
                _this.contactInfo = contact.contactInfo;
                _this.setCardInfoDate();

                _this.hideLoading();
            }, function (error) {
                this.hideLoading();
            });
        }
    }, {
        key: 'getInvestorTypes',
        value: function getInvestorTypes() {
            var _this2 = this;

            this.showLoading();
            this.ApiPicklist.getInvestorTypes().then(function (investorTypes) {
                _this2.investorTypes = investorTypes.data.map(function (investorType) {
                    return investorType.type;
                });
                _this2.hideLoading();
            }, function (error) {
                this.hideLoading();
            });
        }
    }, {
        key: 'getCountries',
        value: function getCountries() {
            var _this3 = this;

            this.showLoading();
            this.ApiPicklist.getAdvindaCountries().then(function (advindaCountries) {
                _this3.advindaCountries = advindaCountries.data;
                _this3.advindaCountries.unshift("");
                _this3.hideLoading();
            }, function (error) {
                this.hideLoading();
            });
        }
    }, {
        key: 'saveContact',
        value: function saveContact() {
            this.checkCardInfoDate();
            if (this.isUpdatedDateNotAfterReceivedDate()) return;
            if (this.isEdit()) this.editContact();else this.insertContact();
        }
    }, {
        key: 'isUpdatedDateNotAfterReceivedDate',
        value: function isUpdatedDateNotAfterReceivedDate() {
            if (this.contactInfo && this.contactInfo.contact && this.contactInfo.contact.businessCardInformationLastUpdatedDate && this.contactInfo.contact.businessCardInformationLastUpdatedDate !== this.DATE_FORMAT) {
                var receivedDate = this.contactInfo.contact.businessCardInformationReceivedDate;
                var updatedDate = this.contactInfo.contact.businessCardInformationLastUpdatedDate;
                var flag = Date.parse(receivedDate) > Date.parse(updatedDate);
                return flag;
            } else {
                return false;
            }
        }
    }, {
        key: 'checkCardInfoDate',
        value: function checkCardInfoDate() {
            if (this.contactInfo.contact.businessCardInformationReceivedDate === this.DATE_FORMAT) {
                this.contactInfo.contact.businessCardInformationReceivedDate = null;
            }
            if (this.contactInfo.contact.businessCardInformationLastUpdatedDate === this.DATE_FORMAT) {
                this.contactInfo.contact.businessCardInformationLastUpdatedDate = null;
            }
        }
    }, {
        key: 'setCardInfoDate',
        value: function setCardInfoDate() {
            if (!this.contactInfo.contact.businessCardInformationReceivedDate) {
                this.contactInfo.contact.businessCardInformationReceivedDate = this.DATE_FORMAT;
            }
            if (!this.contactInfo.contact.businessCardInformationLastUpdatedDate) {
                this.contactInfo.contact.businessCardInformationLastUpdatedDate = this.DATE_FORMAT;
            }
        }
    }, {
        key: 'insertContact',
        value: function insertContact() {
            var _this4 = this;

            this.showLoading();
            this.ApiContacts.postContact(this.contactInfo).then(function (res) {
                _this4.hideLoading();
                if (angular.isUndefined(res)) return;
                _this4.redirectAfterCreate(_this4.contactInfo);
            }, function () {
                this.hideLoading();
            });
        }
    }, {
        key: 'editContact',
        value: function editContact() {
            var _this5 = this;

            this.showLoading();
            this.ApiContacts.putContact(this.contactInfo).then(function (res) {
                _this5.hideLoading();
                if (angular.isUndefined(res)) return;
                _this5.$state.go('contacts', {}, { reload: true });
            }, function () {
                this.hideLoading();
                this.MessageBox.showFailMessage('CONTACT', 'EDIT');
            });
        }
    }, {
        key: 'redirectAfterCreate',
        value: function redirectAfterCreate(contactInfo) {
            var customer = contactInfo.investor.customer;
            var investorId = contactInfo.investor.investorId;
            if (this.investorRedirect) {
                if (customer === null) {
                    this.$state.go('investorsDetail', { investorId: investorId }, { isCustomerInvestor: false });
                } else {
                    this.$state.go('customerInvestorsDetail', { investorId: investorId }, { isCustomerInvestor: true });
                }
            } else {
                this.$state.go('contacts', {}, { reload: true });
            }
        }
    }, {
        key: 'clearInvestorInputs',
        value: function clearInvestorInputs() {
            this.contactInfo.investor = {};
        }
    }, {
        key: 'copyInvestorToContact',
        value: function copyInvestorToContact() {
            if (this.contactInfo && this.contactInfo.investor) {
                if (this.checkIfKeyExistsInInvestorObject('fax')) {
                    this.contactInfo.contact.fax = this.contactInfo.investor.fax;
                }
                if (this.checkIfKeyExistsInInvestorObject('billingCity')) {
                    this.contactInfo.contact.mailingCity = this.contactInfo.investor.billingCity;
                }
                if (this.checkIfKeyExistsInInvestorObject('billingCountry')) {
                    this.contactInfo.contact.mailingCountry = this.contactInfo.investor.billingCountry;
                }
                if (this.checkIfKeyExistsInInvestorObject('billingPostalCode')) {
                    this.contactInfo.contact.mailingPostalCode = this.contactInfo.investor.billingPostalCode;
                }
                if (this.checkIfKeyExistsInInvestorObject('billingState')) {
                    this.contactInfo.contact.mailingState = this.contactInfo.investor.billingState;
                }
                if (this.checkIfKeyExistsInInvestorObject('billingStreet')) {
                    this.contactInfo.contact.mailingStreet = this.contactInfo.investor.billingStreet;
                }
                if (this.checkIfKeyExistsInInvestorObject('additionalPhone')) {
                    this.contactInfo.contact.otherPhone = this.contactInfo.investor.additionalPhone;
                }
                if (this.checkIfKeyExistsInInvestorObject('investorPhone')) {
                    this.contactInfo.contact.phone = this.contactInfo.investor.investorPhone;
                }
                if (this.checkIfKeyExistsInInvestorObject('postalCode')) {
                    this.contactInfo.contact.mailingPostalCode = this.contactInfo.investor.postalCode;
                }
                if (this.checkIfKeyExistsInInvestorObject('additionalAddress')) {
                    this.contactInfo.contact.additionalAddress = this.contactInfo.investor.additionalAddress;
                }
                if (this.checkIfKeyExistsInInvestorObject('additionalZip')) {
                    this.contactInfo.contact.additionalZip = this.contactInfo.investor.additionalZip;
                }
                if (this.checkIfKeyExistsInInvestorObject('additionalCity')) {
                    this.contactInfo.contact.additionalCity = this.contactInfo.investor.additionalCity;
                }
                if (this.checkIfKeyExistsInInvestorObject('additionalState')) {
                    this.contactInfo.contact.additionalState = this.contactInfo.investor.additionalState;
                }
                if (this.checkIfKeyExistsInInvestorObject('additionalCountry')) {
                    this.contactInfo.contact.additionalCountry = this.contactInfo.investor.additionalCountry;
                }
                if (this.checkIfKeyExistsInInvestorObject('additionalInformation')) {
                    this.contactInfo.contact.additionalInformation = this.contactInfo.investor.additionalInformation;
                }

                if (this.checkIfKeyExistsInInvestorObject('countryTranslated')) {
                    this.contactInfo.contact.countryTranslated = this.contactInfo.investor.countryTranslated;
                }
                if (this.checkIfKeyExistsInInvestorObject('stateTranslated')) {
                    this.contactInfo.contact.stateTranslated = this.contactInfo.investor.stateTranslated;
                }
                if (this.checkIfKeyExistsInInvestorObject('zipTranslated')) {
                    this.contactInfo.contact.zipTranslated = this.contactInfo.investor.zipTranslated;
                }
                if (this.checkIfKeyExistsInInvestorObject('cityTranslated')) {
                    this.contactInfo.contact.cityTranslated = this.contactInfo.investor.cityTranslated;
                }
                if (this.checkIfKeyExistsInInvestorObject('addressTranslated')) {
                    this.contactInfo.contact.addressTranslated = this.contactInfo.investor.addressTranslated;
                }
            }
        }
    }, {
        key: 'checkIfKeyExistsInInvestorObject',
        value: function checkIfKeyExistsInInvestorObject(key) {
            if (this.contactInfo && this.contactInfo.investor) {
                return !!this.contactInfo.investor[key];
            } else return false;
        }

        //
        // Account popup functions
        //

    }, {
        key: 'showAccountModal',
        value: function showAccountModal() {
            this.addAccountModal.show();
            this.onInvestorContactsClick(0);
        }
    }, {
        key: 'cancelModal',
        value: function cancelModal() {
            this.searchPerformed = false;
            this.addAccountModal.hide();
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.searchPerformed = false;
            this.getInvestorsAndPopulateValues();
            this.addAccountModal.hide();
        }
    }, {
        key: 'clearSearchAccounts',
        value: function clearSearchAccounts() {
            this.searchAccountText = '';
            this.searchAccounts();
        }
    }, {
        key: 'getInvestorSubtypes',
        value: function getInvestorSubtypes() {
            var _this6 = this;

            this.ApiInvestors.getInvestorsSubtypes().then(function (investorSubtypes) {
                if (investorSubtypes) {
                    _this6.investorSubtypes = investorSubtypes.map(function (subtype) {
                        return { value: subtype };
                    });
                }
            });
        }
    }, {
        key: 'searchAccounts',
        value: function searchAccounts() {
            var _this7 = this;

            this.searchPerformed = true;
            this.filterParameterObj = {
                investorType: undefined,
                subtypes: [],
                selectionId: undefined,
                fromAum: undefined,
                toAum: undefined,
                searchText: this.searchAccountText,
                firstQueryResult: undefined,
                sortOrder: 'AUM',
                sortDirection: 'ASC'
            };

            if (this.filter.accountType.id === 'PACKAGE' && this.investorSubtypes != null) {
                this.investorSubtypes.forEach(function (subtype) {
                    _this7.filterParameterObj.subtypes.push(subtype.value);
                });
            }

            if (this.filter.accountType.id === 'PACKAGE') {
                this.loadPackageAccounts();
            } else {
                this.loadCustomAccounts();
            }
        }
    }, {
        key: 'loadCustomAccounts',
        value: function loadCustomAccounts() {
            var _this8 = this;

            this.loadingData = true;
            this.ApiInvestors.getTeamInvestors(this.filterParameterObj).then(function (investors) {
                if (investors.length < 50) {
                    _this8.investorsMoreData = false;
                } else {
                    _this8.investorsMoreData = true;
                }

                _this8.investors = investors || [];
                _this8.loadingData = false;
            });
        }
    }, {
        key: 'loadPackageAccounts',
        value: function loadPackageAccounts() {
            var _this9 = this;

            this.loadingData = true;
            this.ApiInvestors.getPackageInvestors(this.filterParameterObj).then(function (investors) {
                if (investors.length < 50) {
                    _this9.investorsMoreData = false;
                } else {
                    _this9.investorsMoreData = true;
                }

                _this9.investors = investors || [];
                _this9.loadingData = false;
            });
        }
    }, {
        key: 'getMoreAccounts',
        value: function getMoreAccounts() {
            this.filterParameterObj.firstQueryResult = this.investors && this.investors.length;
            if (this.filter.accountType.id === 'PACKAGE') {
                this.getMorePackageAccounts();
            } else if (this.filter.accountType.id === 'TEAM') {
                this.getMoreCustomAccounts();
            }
        }
    }, {
        key: 'getMorePackageAccounts',
        value: function getMorePackageAccounts() {
            var _this10 = this;

            this.loadingData = true;
            this.ApiInvestors.getPackageInvestors(this.filterParameterObj).then(function (investors) {
                if (!investors) {
                    _this10.investorsMoreData = false;
                } else {
                    _this10.investorsMoreData = investors.length < 50 ? false : true;
                    _this10.investors = _this10.investors.concat(investors);
                    _this10.$scope.$broadcast('scroll.infiniteScrollComplete');
                }
                _this10.loadingData = false;
            });
        }
    }, {
        key: 'getMoreCustomAccounts',
        value: function getMoreCustomAccounts() {
            var _this11 = this;

            this.loadingData = true;
            this.ApiInvestors.getTeamInvestors(this.filterParameterObj).then(function (investors) {
                if (!investors) {
                    _this11.investorsMoreData = false;
                } else {
                    _this11.investorsMoreData = investors.length < 50 ? false : true;
                    _this11.investors = _this11.investors.concat(investors);
                    $scope.$broadcast('scroll.infiniteScrollComplete');
                }
                _this11.loadingData = false;
            });
        }
    }, {
        key: 'onInvestorContactsClick',
        value: function onInvestorContactsClick(buttonNumber) {
            this.accountTypes.map(function (c) {
                return c.selected = false;
            });
            this.accountTypes[buttonNumber].selected = true;
            this.filter.accountType = this.accountTypes[buttonNumber];
            this.searchAccounts();
        }
    }, {
        key: 'getInvestorsAndPopulateValues',
        value: function getInvestorsAndPopulateValues() {
            var _this12 = this;

            if (this.contactInfo.investor) {
                this.contactInfo.contact = this.removeAddressDetails();
                this.ApiInvestors.getInvestor(this.contactInfo.investor.investorId, {
                    'isCustomerAccount': !!this.contactInfo.investor.customer
                }).then(function (investor) {
                    _this12.contactInfo.investor = investor.investor;
                    _this12.copyInvestorToContact();
                });
            }
        }
    }, {
        key: 'removeAddressDetails',
        value: function removeAddressDetails() {
            var contact = _extends({}, this.contactInfo.contact);
            return {
                id: contact.id,
                salutation: contact.salutation,
                firstName: contact.firstName,
                lastName: contact.lastName,
                title: contact.title,
                email: contact.email,
                alternativeEmail: contact.alternativeEmail,
                customer: contact.customer,
                mobile: contact.mobile,
                businessCardInformationReceivedDate: this.contactInfo.contact.businessCardInformationReceivedDate !== this.DATE_FORMAT ? this.contactInfo.contact.businessCardInformationReceivedDate : this.DATE_FORMAT,
                businessCardInformationLastUpdatedDate: this.contactInfo.contact.businessCardInformationLastUpdatedDate !== this.DATE_FORMAT ? this.contactInfo.contact.businessCardInformationLastUpdatedDate : this.DATE_FORMAT

            };
        }
    }, {
        key: 'getTeams',
        value: function getTeams() {
            var _this13 = this;

            this.ApiTeam.getTeams().then(function (res) {
                if (typeof res != 'undefined') {
                    if (res) {
                        _this13.translationVisible = res.translationRequired;
                    }
                }
            });
        }
    }]);

    return ContactAddController;
}();

exports.default = ContactAddController;


/** WEBPACK FOOTER **
 ** ./src/app/components/contacts/contactAdd.controller.js
 **/